import React, { FC } from "react";

// Subheading Component
const SubScreenHeading:FC<{text: string, customClass?: string}> = ({ text, customClass = "text-xl" }) => {
  return <h2 className={`${customClass}  font-bold font-[PINYADA-Beranda-Regular]`}>{text}</h2>;
};


export default SubScreenHeading;